import { Component, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageAssistanceService } from './service/message-tasa-assistance.service';
import { ChangeDetectorRef } from '@angular/core';
import { SimpleUserData } from 'src/app/core/auth/authData.model';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Observable } from 'rxjs';
import { AlertService } from 'src/app/services/alerts.service';
import { Title } from '@angular/platform-browser';
import Swal from 'sweetalert2';

// ========== INTERFACES ==========
interface ChatMessage {
    sender: 'user' | 'bot';
    message: string;
    audio?: boolean;
    audioUrl?: string;
    file?: {
        name: string;
        size: number;
        type: string;
        url: string;
        icon: string;
    };
    timestamp?: Date;
}

@Component({
    selector: 'app-chat-tasa-layout-assistance',
    templateUrl: './chat-tasa-layout-assistance.component.html',
    styleUrl: './chat-tasa-layout-assistance.component.scss',
})
export class ChatTasaLayoutAssistanceComponent {

    private readonly WEBHOOK_URL = 'https://agencycic.app.n8n.cloud/webhook/clarity-web';

    /* ============== ATRIBUTES ============== */
    userData?: SimpleUserData;
    hasAccess$: Observable<boolean>;

    selectedFile: File | null = null;
    fileTypeOpt: { [key: string]: string } = {
        'application/pdf': 'assets/icons/home/pdf_filetype_icon.svg',
        'text/plain': 'assets/icons/home/txt_filetype_icon.svg',
        'application/msword': 'assets/icons/home/doc_filetype_icon.svg',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            'assets/icons/home/doc_filetype_icon.svg',
    };
    fileType: string = '';

    messages: ChatMessage[] = [];
    newMessageUser: string = '';
    errorMessages: string[] = [];

    isThinking: boolean = false;
    isTyping: boolean = false;

    speak: boolean = false;
    showAudio: string = 'no';

    stream: MediaStream | null = null;
    mediaRecorder: MediaRecorder | null = null;
    isRecording: boolean = false;
    audioChunks: Blob[] = [];
    title = 'Clarity Chat';

    idCliente: string = 'no';
    thread_id: string = 'nada';

    ind: number = 29;
    audio_nom: string = 'no';
    volumeUp: string = 'no';
    humanOn: string = 'no';
    espqr: string = 'no';

    asistenteIdOpenIa: string = 'asst_T6xPCHboGUCjQv0C5tfw3dxT';
    instrucciones: string = 'INSTR_VALOR_MAS';
    id_asistente: string = '5';
    empresa_modelo: string = 'OpenAI';
    ruta_script: string = '/var/www/cobra/DESARROLLO/valormas/ejecutable_valormas.sh';

    isOverflowing: boolean = true;
    isProcessingMic = false;
    isWaitingForAIResponse = false;
    lastMicClickTime: number = 0;
    micDebounceTime: number = 1000;
    readonly MAX_MESSAGE_LENGTH: number = 1000;
    recordingTime: number = 0;
    recordingInterval: any;
    isCancellingRecording: boolean = false;

    chatSessionId: string = '';

    @ViewChild('chatbox') chatbox!: ElementRef;
    @ViewChild('messageInput') messageInput!: ElementRef;
    @ViewChild('chatSection') chatSection!: ElementRef;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

    /* ============== CONSTRUCTOR ============== */
    constructor(
        private titleService: Title,
        private http: HttpClient,
        private messageAssistanceService: MessageAssistanceService,
        private cdr: ChangeDetectorRef,
        public authService: AuthService,
        private alertService: AlertService,
    ) {
        this.messages = [];
        this.hasAccess$ = this.authService.getAccessStatus();
    }

    ngOnInit(): void {
        this.titleService.setTitle(this.title);

        try {
            this.userData = JSON.parse(sessionStorage.getItem('user') || '{}');
        } catch (error) {
            this.userData = {};
        }

        this.chatSessionId = this.messageAssistanceService.getOrCreateSessionId();
        this.addWelcomeMessage();
    }

    ngAfterViewChecked() {
        if (this.isNearBottom()) {
            this.scrollToBottom();
        }
    }

    ngAfterViewInit() {
        this.scrollToBottom();
    }

    ngOnDestroy() {
        if (this.recordingInterval) {
            clearInterval(this.recordingInterval);
            this.recordingInterval = null;
        }

        const wasRecording = this.isRecording;
        const hadStream = !!this.stream;

        this.isWaitingForAIResponse = false;
        this.isProcessingMic = false;
        this.isRecording = false;
        this.isTyping = false;
        this.isThinking = false;

        if (wasRecording && this.mediaRecorder) {
            try {
                if (this.mediaRecorder.state === 'recording') {
                    this.mediaRecorder.stop();
                }
            } catch (error) {}
        }

        if (hadStream && this.stream) {
            try {
                this.stream.getTracks().forEach(track => {
                    if (track.readyState === 'live') {
                        track.stop();
                    }
                });
            } catch (error) {}
        }

        this.messages.forEach(message => {
            if (message.audioUrl && message.audioUrl.startsWith('blob:')) {
                URL.revokeObjectURL(message.audioUrl);
            }
        });

        this.stream = null;
        this.mediaRecorder = null;
        this.audioChunks = [];
    }

    canSendMessage(): boolean {
        return !this.isThinking && !this.isTyping && !this.isWaitingForAIResponse;
    }

    // ========== ENVÍO DE MENSAJES ==========

    sendMessage() {
        if (!this.canSendMessage()) {
            return;
        }

        if (this.selectedFile) {
            this.alertService.showAlert(
                'El envío de archivos no está disponible. Solo se procesará el mensaje de texto.',
                'warning'
            );
            this.clearFile();
        }

        if (this.newMessageUser.trim() !== '') {
            this.messages.push({
                sender: 'user',
                message: this.newMessageUser,
                timestamp: new Date()
            });

            const userMessage = this.newMessageUser.trim();
            this.newMessageUser = '';

            if (this.messageInput && this.messageInput.nativeElement) {
                const textarea = this.messageInput.nativeElement;
                textarea.value = '';
                textarea.style.height = '38px';
                textarea.rows = 1;
                textarea.scrollTop = 0;
            }

            this.isThinking = true;
            this.isWaitingForAIResponse = true;
            this.cdr.detectChanges();
            this.scrollToBottom();

            this.sendMessageToN8n(userMessage);
        }
    }

    private sendMessageToN8n(message: string) {
        if (!this.chatSessionId) {
            this.chatSessionId = this.messageAssistanceService.getOrCreateSessionId();
        }

        const payload = {
            sessionId: this.chatSessionId,
            pregunta: message,
            audio_enabled: this.speak
        };

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        this.http.post<any>(this.WEBHOOK_URL, payload, { headers }).subscribe({
            next: (response: any) => {
                this.isWaitingForAIResponse = false;
                this.isProcessingMic = false;
                this.isThinking = false;

                const output = this.parseWebhookResponse(response);
                if (output) {
                    const formattedResponse = this.formatearRespuestaN8n(output);
                    this.displayMessageWithTypingEffect(formattedResponse, 'bot', false, undefined);
                } else {
                    this.mostrarErrorAleatorio();
                }

                this.scrollToBottom();
            },
            error: () => {
                this.isWaitingForAIResponse = false;
                this.isProcessingMic = false;
                this.isThinking = false;
                this.mostrarErrorAleatorio();
            }
        });
    }

    private parseWebhookResponse(response: any): string | null {
        if (!response) return null;

        if (Array.isArray(response) && response.length > 0) {
            const first = response[0];
            return first?.output || first?.text || first?.message || null;
        }

        const candidates = [
            response?.output,
            response?.data?.output,
            response?.text,
            response?.data?.text,
            response?.message,
            response?.data?.message
        ];

        for (const c of candidates) {
            if (c && typeof c === 'string' && c.trim().length > 0) return c.trim();
        }

        return null;
    }

    // ========== GRABACIÓN ==========

    toggleRecording() {
        const currentTime = Date.now();
        if (currentTime - this.lastMicClickTime < 1500) {
            return;
        }
        this.lastMicClickTime = currentTime;

        if (this.isProcessingMic || this.isWaitingForAIResponse || this.isThinking || this.isTyping) {
            return;
        }

        if (this.isRecording) {
            this.isProcessingMic = true;
            this.stopRecording();
        } else {
            this.isProcessingMic = true;
            this.startRecording();
        }
    }

    toggleSpeak() {
        this.speak = !this.speak;
        if (!this.speak) {
            this.volumeUp = 'no';
            this.humanOn = 'no';
        } else {
            this.volumeUp = 'si';
            this.humanOn = 'si';
        }
    }

    // ========== MÉTODOS AUXILIARES ==========

    private formatearRespuestaN8n(output: string): string {
        if (!output) return 'Lo siento, no pude procesar tu mensaje. Intenta de nuevo.';

        return output
            .replace(/\s{2,}/g, '<br>')
            .replace(/\n+/g, '<br>')
            .replace(/\\n/g, '<br>')
            .replace(/\\r\\n/g, '<br>')
            .replace(/\\r/g, '<br>')
            .replace(/【[^】]*】/g, '')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/<br>-\s+(.+)/g, '<br>• $1')
            .replace(/^-\s+(.+)/gm, '• $1')
            .replace(
                /(https?:\/\/[a-zA-Z0-9\-._~:/?#@!'()*+,;=%]+)/g,
                '<a class="agata-link" href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
            )
            .replace(/(<br>\s*){3,}/g, '<br><br>')
            .replace(/^(<br>\s*)+/, '')
            .trim();
    }

    displayMessageWithTypingEffect(
        message: string,
        type: 'user' | 'bot',
        audio: boolean,
        audioUrlSrc?: string
    ) {
        this.isThinking = false;
        this.isTyping = true;
        this.isWaitingForAIResponse = true;

        const newMessage: ChatMessage = {
            sender: type,
            message: '',
            audio: audio,
            audioUrl: audioUrlSrc,
            timestamp: new Date()
        };
        this.messages.push(newMessage);

        let i = 0;
        let intervalId: any;
        let lastTime = Date.now();
        const typingSpeed = 25;

        const typeWriter = () => {
            const currentTime = Date.now();
            const elapsedTime = currentTime - lastTime;
            const charsToAdd = Math.floor(elapsedTime / typingSpeed);

            if (charsToAdd > 0 && i < message.length) {
                const endIndex = Math.min(i + charsToAdd, message.length);
                newMessage.message += message.substring(i, endIndex);
                i = endIndex;
                lastTime = currentTime;

                if (this.isNearBottom()) {
                    this.scrollToBottom();
                }

                if (i >= message.length) {
                    this.isTyping = false;
                    this.isThinking = false;
                    this.isWaitingForAIResponse = false;
                    clearInterval(intervalId);
                }
            }
        };

        intervalId = setInterval(typeWriter, 25);
    }

    private mostrarErrorAleatorio() {
        setTimeout(() => {
            const MsgAleatorio = this.MensajesError();
            this.displayMessageWithTypingEffect(
                MsgAleatorio,
                'bot',
                false,
                undefined
            );
            this.scrollToBottom();
        }, 2000);
    }

    MensajesError() {
        const errorMessages: string[] = [
            'Oops, parece que algo salió mal 🙃 ¡Intentémoslo de nuevo!',
            'Ups, algo no fue como esperábamos 🧐 ¿Lo intentamos otra vez?',
            'Parece que se nos cayó el mensaje 🛠, pero lo intentamos de nuevo!',
            '¡Vaya! Este mensaje decidió tomarse un descanso 😅 ¡Prueba enviarlo otra vez!',
            'El mensaje no quiso salir 🤷‍♀, pero lo intentamos una vez más.',
        ];

        const randomIndex = Math.floor(Math.random() * errorMessages.length);
        return errorMessages[randomIndex];
    }

    handleKeyPress(event: KeyboardEvent) {
        if (
            event.key === 'Enter' &&
            this.newMessageUser.trim() !== '' &&
            this.canSendMessage()
        ) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    autoResize(event: Event) {
        const textarea = event.target as HTMLTextAreaElement;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
        this.isOverflowing = textarea.scrollHeight > textarea.clientHeight;
    }

    cancelRecording(): void {
        if (!this.isRecording) {
            return;
        }
        this.isCancellingRecording = true;
        if (this.recordingInterval) {
            clearInterval(this.recordingInterval);
            this.recordingInterval = null;
        }
        this.audioChunks = [];
        if (this.mediaRecorder) {
            try {
                if (this.mediaRecorder.state === 'recording') {
                    this.mediaRecorder.stop();
                }
            } catch (error) {
                console.error('Error deteniendo MediaRecorder:', error);
            }
        }
        if (this.stream) {
            this.stream.getTracks().forEach(track => {
                try {
                    track.stop();
                } catch (error) {
                    console.error('Error deteniendo track:', error);
                }
            });
            this.stream = null;
        }
        this.isRecording = false;
        this.isProcessingMic = false;
        this.isWaitingForAIResponse = false;
        this.recordingTime = 0;
        this.mediaRecorder = null;
        Swal.fire({
            icon: 'info',
            title: 'Grabación cancelada',
            text: 'El audio no fue enviado.',
            confirmButtonColor: '#1d8549',
            confirmButtonText: 'Entendido',
            timer: 2000,
            timerProgressBar: true
        });
        setTimeout(() => {
            this.isCancellingRecording = false;
        }, 1000);
        this.cdr.detectChanges();
    }

    stopRecording() {
        if (!this.mediaRecorder || !this.isRecording) {
            this.isProcessingMic = false;
            return;
        }
        if (this.recordingInterval) {
            clearInterval(this.recordingInterval);
            this.recordingInterval = null;
        }
        try {
            this.isRecording = false;
            this.mediaRecorder.stop();
            this.isWaitingForAIResponse = true;
        } catch (error) {
            this.isRecording = false;
            this.isProcessingMic = false;
            this.isWaitingForAIResponse = false;
            Swal.fire({
                icon: 'error',
                title: 'Error al grabar',
                text: 'Ocurrió un error al procesar el audio.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Entendido'
            });
        }
        setTimeout(() => {
            if (this.stream) {
                try {
                    this.stream.getTracks().forEach(track => {
                        track.stop();
                    });
                    this.stream = null;
                } catch (error) {}
            }
        }, 500);
    }

    startRecording() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            Swal.fire({
                icon: 'error',
                title: 'Navegador incompatible',
                text: 'Tu navegador no soporta grabación de audio.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Entendido'
            });
            this.isProcessingMic = false;
            return;
        }

        if (this.isRecording || this.mediaRecorder) {
            this.stopRecording();
        }

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
                this.stream = stream;
                this.audioChunks = [];

                try {
                    const isIOS = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
                    let options = {};
                    let fileExtension = '.webm';

                    const mimeTypes = isIOS
                        ? ['audio/mp4', 'audio/aac', 'audio/wav']
                        : ['audio/webm', 'audio/ogg', 'audio/wav'];

                    for (const type of mimeTypes) {
                        if (MediaRecorder.isTypeSupported(type)) {
                            options = { mimeType: type };
                            fileExtension = type.includes('webm') ? '.webm' :
                                type.includes('ogg') ? '.ogg' :
                                    type.includes('mp4') ? '.mp4' :
                                        type.includes('aac') ? '.aac' : '.wav';
                            break;
                        }
                    }

                    const maxRecordingDuration = 60000;
                    let recordingTimeout: any;

                    this.mediaRecorder = new MediaRecorder(stream, options);
                    const timeslice = isIOS ? 100 : 1000;
                    this.mediaRecorder.start(timeslice);
                    this.isRecording = true;
                    this.isProcessingMic = false;

                    this.recordingTime = 0;
                    this.recordingInterval = setInterval(() => {
                        this.recordingTime++;
                    }, 1000);

                    recordingTimeout = setTimeout(() => {
                        if (this.isRecording) {
                            this.stopRecording();
                        }
                    }, maxRecordingDuration);

                    this.mediaRecorder.addEventListener('dataavailable', (event) => {
                        if (event.data && event.data.size > 0) {
                            this.audioChunks.push(event.data);
                        }
                    });

                    this.mediaRecorder.addEventListener('stop', () => {
                        if (recordingTimeout) {
                            clearTimeout(recordingTimeout);
                        }

                        if (this.isCancellingRecording) {
                            this.isWaitingForAIResponse = false;
                            this.isProcessingMic = false;
                            return;
                        }

                        setTimeout(() => {
                            if (this.isCancellingRecording) {
                                this.isWaitingForAIResponse = false;
                                this.isProcessingMic = false;
                                return;
                            }

                            if (this.audioChunks.length === 0) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'No se grabó audio',
                                    text: 'No se pudo grabar audio. Inténtalo de nuevo.',
                                    confirmButtonColor: '#1d8549',
                                    confirmButtonText: 'Reintentar'
                                });
                                this.isWaitingForAIResponse = false;
                                this.isProcessingMic = false;
                                return;
                            }

                            const audioBlob = new Blob(this.audioChunks, {
                                type: this.mediaRecorder?.mimeType || 'audio/webm'
                            });

                            if (audioBlob.size < 100) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Grabación muy corta',
                                    text: 'La grabación fue muy corta o falló. Inténtalo de nuevo.',
                                    confirmButtonColor: '#1d8549',
                                    confirmButtonText: 'Reintentar'
                                });
                                this.isWaitingForAIResponse = false;
                                this.isProcessingMic = false;
                                return;
                            }

                            this.sendAudioToBackend(audioBlob, `audio_message${fileExtension}`);
                        }, isIOS ? 300 : 200);
                    });

                    this.mediaRecorder.addEventListener('error', (event) => {
                        this.isRecording = false;
                        this.isProcessingMic = false;
                        this.isWaitingForAIResponse = false;

                        if (this.recordingInterval) {
                            clearInterval(this.recordingInterval);
                            this.recordingInterval = null;
                        }

                        if (recordingTimeout) {
                            clearTimeout(recordingTimeout);
                        }

                        Swal.fire({
                            icon: 'error',
                            title: 'Error en la grabación',
                            text: 'Ocurrió un error durante la grabación.',
                            confirmButtonColor: '#1d8549',
                            confirmButtonText: 'Entendido'
                        });
                    });

                } catch (error) {
                    if (this.recordingInterval) {
                        clearInterval(this.recordingInterval);
                        this.recordingInterval = null;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Formato no soportado',
                        text: 'Tu navegador no soporta la grabación con los formatos disponibles.',
                        confirmButtonColor: '#1d8549',
                        confirmButtonText: 'Entendido'
                    });
                    this.isProcessingMic = false;
                    this.isRecording = false;

                    if (this.stream) {
                        this.stream.getTracks().forEach(track => track.stop());
                        this.stream = null;
                    }
                }
            })
            .catch((err) => {
                this.isProcessingMic = false;
                this.isRecording = false;

                if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Permiso denegado',
                        html: '<p>Acceso al micrófono denegado.</p>',
                        confirmButtonColor: '#1d8549',
                        confirmButtonText: 'Entendido'
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error de micrófono',
                        text: 'Error al acceder al micrófono: ' + err.message,
                        confirmButtonColor: '#1d8549',
                        confirmButtonText: 'Entendido'
                    });
                }
            });
    }

    sendAudioToBackend(audioBlob: Blob, filename: string = 'audio_message.webm') {
        if (this.isCancellingRecording) {
            return;
        }

        if (!audioBlob || audioBlob.size <= 0) {
            this.isWaitingForAIResponse = false;
            this.isProcessingMic = false;

            Swal.fire({
                icon: 'warning',
                title: 'Audio vacío',
                text: 'No se pudo grabar audio.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Reintentar'
            });
            return;
        }

        this.messageAssistanceService.sendAudioToBackend(audioBlob, filename).subscribe({
            next: (response: any) => {
                if (response.success) {
                    this.isWaitingForAIResponse = false;
                    this.isProcessingMic = false;

                    this.newMessageUser = response.data;
                    this.sendMessage();
                } else {
                    this.isWaitingForAIResponse = false;
                    this.isProcessingMic = false;

                    if (response.message) {
                        const mensaje = response.message.toLowerCase();

                        if (mensaje.includes('no te pudimos escuchar') ||
                            mensaje.includes('demasiado corto') ||
                            mensaje.includes('habla más cerca') ||
                            mensaje.includes('claramente') ||
                            mensaje.includes('ruido de fondo') ||
                            mensaje.includes('resultó demasiado corto') ||
                            mensaje.includes('idioma') ||
                            mensaje.includes('español') ||
                            mensaje.includes('inglés')) {

                            Swal.fire({
                                icon: 'warning',
                                title: '¡No te escuchamos!',
                                html: `
                                    <p class="mb-3">El audio resultó demasiado corto o fue afectado por ruido de ambiente.</p>
                                    <div class="text-sm text-gray-600 text-left bg-gray-50 p-3 rounded mt-3">
                                        <p class="font-semibold mb-2">💡 Consejos:</p>
                                        <ul class="space-y-1">
                                            <li>• Habla cerca del micrófono</li>
                                            <li>• Graba por más de 1 segundo</li>
                                            <li>• Evita lugares ruidosos</li>
                                        </ul>
                                    </div>
                                `,
                                confirmButtonColor: '#1d8549',
                                confirmButtonText: 'Intentar de nuevo',
                                allowOutsideClick: false
                            });
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error al procesar',
                                text: response.message,
                                confirmButtonColor: '#1d8549',
                                confirmButtonText: 'Reintentar'
                            });
                        }
                    }
                }
            },
            error: (error) => {
                this.isTyping = false;
                this.isWaitingForAIResponse = false;
                this.isProcessingMic = false;

                let errorTitle = 'Error de conexión';
                let errorMessage = '';
                let iconType: 'error' | 'warning' = 'error';

                if (error.status === 0) {
                    errorTitle = 'Sin conexión';
                    errorMessage = 'No hay conexión con el servidor.';
                    iconType = 'warning';
                } else if (error.status >= 500) {
                    errorTitle = 'Error del servidor';
                    errorMessage = 'El servidor está experimentando problemas.';
                } else {
                    errorMessage = 'No se pudo enviar el audio.';
                }

                Swal.fire({
                    icon: iconType,
                    title: errorTitle,
                    text: errorMessage,
                    confirmButtonColor: '#1d8549',
                    confirmButtonText: 'Entendido'
                });
            }
        });
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];

        if (file && file.type in this.fileTypeOpt) {
            this.alertService.showAlert(
                'Nota: El envío de archivos no está disponible.',
                'warning'
            );

            this.selectedFile = file;
            this.fileType = this.fileTypeOpt[file.type];
        } else {
            this.alertService.showAlert(
                'El archivo seleccionado no es válido.',
                'warning'
            );
        }

        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
    }

    clearFile(): void {
        this.selectedFile = null;
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
    }

    getFileExtension(filename: string): string {
        const parts = filename.split('.');
        return parts.length > 1
            ? parts[parts.length - 1].toUpperCase()
            : 'UNKNOWN';
    }

    isNearBottom(): boolean {
        const threshold = 80;
        const chatbox = this.chatbox.nativeElement;
        const position = chatbox.scrollTop + chatbox.offsetHeight;
        const height = chatbox.scrollHeight;
        return height - position <= threshold;
    }

    scrollToBottom(): void {
        const chatbox = this.chatbox.nativeElement;
        chatbox.scrollTop = chatbox.scrollHeight;
    }

    private addWelcomeMessage(customMessage?: string): void {
        setTimeout(() => {
            const welcomeMessage: ChatMessage = {
                sender: 'bot',
                message: customMessage || 'Hola! Soy tu asistente de Clarity IA. ¿En qué puedo ayudarte hoy?',
                audio: false,
                timestamp: new Date()
            };
            this.messages.push(welcomeMessage);
            this.scrollToBottom();
            this.cdr.detectChanges();
        }, 1000);
    }
}
